import { getCrmCompanyId, getCrmDashboardRoutes } from '@crm/shared/config'

import { getCrmTariffUpgradeUrl } from '../lib/getCrmTariffUpgradeUrl'

declare const routable:
  | {
      setRoute?: (key: string, url: string) => void
    }
  | undefined

export const registerHardcodedDashboardRoutes = (projectId: number) => {
  const dashboardRoutes = getCrmDashboardRoutes()
  const companyId = getCrmCompanyId()
  const normalizeProjectRoute = (url: string) =>
    url.replace(/\/project\/\d+/, `/project/${projectId}`)

  const fallbackRoutes = {
    openChangeTariff: getCrmTariffUpgradeUrl().toString(),
    projectDashboard: `/project/${projectId}/dashboard`,
    editProjectInfo: `/project/${projectId}/dashboard/info`,
    updateCustomer: `/project/${projectId}/partner/_companyPartner_`,
    createCustomer: `/project/${projectId}/partner`,
    getCustomer: `/project/${projectId}/partner/_customerId_`,
    dadataLoadRequisites: '/load-requisites',
    deleteCustomer: `/project/${projectId}/customer`,
    selectCustomer: `/project/${projectId}/select-customer`,
    selectLegalEntity: `/project/${projectId}/select-legal-entity`,
    getManager: `/project/${projectId}/manager/_managerId_`,
    createManager: `/project/${projectId}/manager`,
    updateManager: `/project/${projectId}/manager/_managerId_`,
    deleteManager: `/project/${projectId}/manager/_managerId_`,
    findEmployeeList: `/company/${companyId}/employee/search`,
    addProjectUserDash: `/project/${projectId}/project_user/add`,
    deleteProjectUserDash: `/project/${projectId}/project_user/_projectUserId_`,
    uploadProjectPhotoAjaxUrl: `/project/${projectId}/photos/upload`,
    removeProjectPhotoAjaxUrl: `/project/${projectId}/photos/_id_/remove`,
    getVisualization: `/project/${projectId}/photos`,
    projectWeather: `/project/${projectId}/weather`,
    getReconciliation: `/project/${projectId}/dashboard/financial-info/reconciliation`,
    getFiles: `/project/${projectId}/folder`,
    addFiles: `/project/${projectId}/attachment/add`,
    downloadObject: `/project/${projectId}/folder/_folder_/download`,
    createFolder: `/project/${projectId}/folder`,
    deleteFile: `/project/${projectId}/attachment/_attachmentId_/remove`,
    deleteFolder: `/project/${projectId}/folder/_folderId_/delete`,
    moveObject: `/project/${projectId}/folder/move`,
    renameFile: `/project/${projectId}/attachment/_attachmentId_/rename`,
    renameFolder: `/project/${projectId}/folder/_folderId_/rename`,
    addMeasurement: `/project/${projectId}/measurement`,
    listProjectMeasurement: `/project/${projectId}/measurement/list`,
    listProjectMeasurementActions: `/project/${projectId}/measurement/actions`,
    generateProjectMeasurement: `/project/${projectId}/measurement/ai/generate`,
    getMeasurement: `/project/${projectId}/measurement/_measurementId_`,
    removeMeasurement: `/project/${projectId}/measurement/_measurementId_/remove`,
    editMeasurement: `/project/${projectId}/measurement/_measurementId_`,
    exportAct: `/project/${projectId}/export-act`,
    exportActAppointmentOfResponsible: `/project/${projectId}/export-act-appointment-of-responsible`,
    exportActExaminationOfHiddenWorks: `/project/${projectId}/export-act-examination-of-hidden-works`,
    exportProjectSummary: `/project/${projectId}/export-summary`,
    exportContractAgreement: `/project/${projectId}/export-contract-agreement`,
    exportCustomContractAgreement: `/project/${projectId}/export-custom_contract-agreement`,
    exportCustomCommercialProposal: `/project/${projectId}/export-custom_commercial-proposal`,
    eventJournalList: `/project/${projectId}/event-journal`,
    eventJournalCreate: `/project/${projectId}/event-journal`,
    eventJournalDelete: `/project/${projectId}/event-journal/_eventJournalId_/remove`,
    eventJournalUpdate: `/project/${projectId}/event-journal/_eventJournalId_/update`,
    eventJournalContext: `/project/${projectId}/event-journal/context`,
    stepByStepMediaUpload: `/project/${projectId}/step-by-step-media/bulk-upload`,
    stepByStepMediaListAjax: `/project/${projectId}/step-by-step-media`,
    stepByStepMediaAddToAlbums: `/project/${projectId}/step-by-step-media/add-to-albums`,
    removeStepByStepMediaAjaxUrl: `/project/${projectId}/step-by-step-media/_id_/remove`,
    updateStepByStepMediaInfoAjaxUrl: `/project/${projectId}/step-by-step-media/_id_/update-info`,
  }

  Object.entries({
    ...fallbackRoutes,
    ...dashboardRoutes,
  }).forEach(([key, url]) => {
    routable?.setRoute?.(key, normalizeProjectRoute(url))
  })
}
